module.exports = __webpack_public_path__ + "img/server_down.73eb9936.svg";